import { mapState, mapGetters, mapMutations } from 'vuex'
import { $shopApi } from '@/utils/http/modules/shop/shop.request'
import TYPES from '../store/mutation-types'
import useMiniappParams from '@/utils/http/middleware/useMiniappParams'
import generateBackground from '@/utils/getThemeColor.js'
import { updateCssVariables } from '@/utils/utils'

export default {
  data() {
    return {
      storeColor: '',
    }
  },
  computed: {
    ...mapState([
      'cdnPath',
      'zbvd',
      'customLive',
      'isWx',
      'vzandesc',
      'env',
      'platform',
      'isIOS',
      'isMiniProgram',
      'userInfo',
      'isPrivateDomain',
    ]),
    ...mapGetters(['storeStyleInfo']),
    storeColorObj() {
      return function (type) {
        if (type == 'color') {
          return {
            color: this.storeColor,
          }
        } else if (type == 'bg') {
          return {
            backgroundColor: this.storeColor,
          }
        }
        return null
      }
    },
  },
  methods: {
    // 获取店铺颜色值
    async getStyleInfo(zbid, callback) {
      const MiniAppData = await useMiniappParams()
      // 小程序默认皮肤
      if (this.isMiniProgram && !MiniAppData.isVzanMini) {
        this.storeColor = '#006cff'
        this.updateStoreStyleInfo({
          color: '#006cff',
        })
        return
      }
      try {
        console.log('getStyleInfo', this.storeStyleInfo)
        if (this.storeStyleInfo) {
          this.storeColor = this.storeStyleInfo.color || '#006CFF'
          callback &&
            callback({
              color: this.storeStyleInfo.color || '#006CFF',
            })
        } else {
          let res = await $shopApi.getStoreStyleInfo(
            zbid,
            this.isMiniProgram ? 158 : 121
          )
          console.log(res)
          const root = document.documentElement
          if (res.dataObj && res.dataObj.attrval) {
            let info = JSON.parse(res.dataObj.attrval)
            // 兼容旧数据，ui调整颜色
            if (info.color === '#00B849') {
              info.color = '#1EAA55'
            }
            this.updateStoreStyleInfo(info)
            this.storeColor = info.color || '#006CFF'
            // 设置生鲜行业主题
            this.setFreshColor(info.color)
            callback &&
              callback({
                color: info.color || '#006CFF',
              })
          } else {
            this.updateStoreStyleInfo(null)
            this.setFreshColor()
            this.storeColor = '#006cff'
            callback &&
              callback({
                color: '#006cff',
              })
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    setFreshColor(color) {
      // 生鲜主题默认 #1EAA55
      let freshColorVar = generateBackground(color || '#1EAA55')
      updateCssVariables(freshColorVar)
    },
    ...mapMutations({
      updateStoreStyleInfo: TYPES.setStoreStyleInfo,
    }),
  },
}

const attrTypeEnums = Object.freeze({
  // 未开户分佣
  healthNoAccount: 263,
})
export const fenyongMixins = {
  data() {
    return {
      attrTypeDic: {
        [attrTypeEnums.healthNoAccount]: undefined,
      },
      // 未开户支持分佣
      isOpenFenYong263: false,
    }
  },
  methods: {
    // 是否开启直播间属性
    async isOpenFenYong(zbid, type) {
      let val = this.attrTypeDic[[type]]
      if (val !== undefined) return val
      let res = await $shopApi.get_site_attribute_value_cache(zbid, type)
      val = res.dataObj.attrval
      this.attrTypeDic[[type]] = val
      return val === '1'
    },
  },
  async mounted() {
    this.isOpenFenYong263 = await this.isOpenFenYong(
      window.zbvd.zbid,
      attrTypeEnums.healthNoAccount
    )
  },
}
